import React, { FC, useCallback, useState } from "react";
import { Dialog, ButtonProps } from "@xapp/components";

import { BasicIntegrationCard, IntegrationCardProp, IntegrationConnectionProps } from "./BasicIntegrationCard";

export interface ServiceTitanConnectionProps extends IntegrationConnectionProps {
    integration: "servicetitan";
    tenantId: string;
}

export interface ServiceTitanIntegrationCardProps extends IntegrationCardProp {
    tenantId?: string;
    /**
     * Optional body content for the dialog that displays below the tenant ID input box.
     */
    bodyContent?: string | JSX.Element;
    /**
     * Connect ServiceTitan
     */
    onConnect?(props: ServiceTitanConnectionProps): void;
}

export const ServiceTitanIntegrationCard: FC<ServiceTitanIntegrationCardProps> = (props) => {

    const { checked, disabled, isLinked, isActive, onDisconnect } = props;

    // const [tenantId, setTenantId] = useState<string>(props.tenantId || "");
    const [showDialog, setShowDialog] = useState<boolean>(false);

    const handleServiceTitanClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
        e.preventDefault();

        if (typeof checked === "boolean") {
            if (typeof props.onClick === "function") {
                props.onClick(e);
            }
        } else {
            // pop up modal
            setShowDialog(true);
        }
    };

    /*
    const handleConnectServiceTitan = useCallback(() => {
        if (typeof onConnect === "function") {
            onConnect({ integration: "servicetitan", tenantId });
        }
    }, [onConnect, tenantId]); */

    const handleDisconnectServiceTitan = useCallback(() => {
        if (typeof onDisconnect === "function") {
            onDisconnect();
            setShowDialog(false);
        }
    }, [onDisconnect]);

    const actions: ButtonProps[] = [
        {
            label: "Close",
            variation: "secondary",
            onClick: () => { setShowDialog(false) }
        }
    ];

    /*
    if (typeof onConnect === "function") {
        // need to update API before we can turn this back on.
        actions.push({
            label: "Connect",
            disabled: !tenantId,
            onClick: handleConnectServiceTitan
        });
    }  */

    return (
        <>
            <BasicIntegrationCard
                checked={checked}
                disabled={disabled}
                imageUrl="/img/integrations/servicetitan/service-titan-logo.png"
                text="ServiceTitan"
                href={() => "/integrations/servicetitan"}
                onClick={handleServiceTitanClick}
                isLinked={isLinked}
                isActive={isActive}
                onDisconnect={typeof onDisconnect === "function" ? handleDisconnectServiceTitan : undefined}
            />
            <Dialog
                active={showDialog}
                actions={actions}
                title="ServiceTitan Setup"
                onClose={() => { setShowDialog(false) }}
            >
                <div style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}>
                    <div>
                        <p>First step if for you to provide us with your ServiceTitan Tenant ID.</p>
                        <p>We then enable your tenant to access our integration.</p>
                    </div>
                    {/*
                <div style={{ marginTop: "10px", marginBottom: "10px" }}>
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    <Input label="ServiceTitan Tenant ID" value={tenantId} onChange={setTenantId} />
                </div>
                */}
                    <div>
                        <b>How do I find my tenant ID?</b>
                        <p>The Tenant ID can be found on your Service Titan account under "Integrations" then "API Application Access"</p>
                    </div>
                    <div>
                        <b>What happens next?</b>
                        <p>We will be following up with you after we enable the integration in your ServiceTitan account.</p>

                        <p>Complete instructions can be found <a target="_blank" href={"https://documentation.xapp.ai/help/integrations/integration-service-titan"} rel="noreferrer">here</a></p>
                    </div>
                    <b>Please email your tenant ID to <a href="mailto:support@xapp.ai?subject=ServiceTitan%20Integration%20Tenant%20ID">support@xapp.ai</a></b>
                </div>
            </Dialog>
        </>
    );
}
